import { IPrismicRichText } from '@monofront/types';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';

interface ITextProps {
  title: IPrismicRichText;
  text: IPrismicRichText;
}

export const Text: React.FC<ITextProps> = ({ title, text }) => (
  <>
    <RichText render={title} />
    <RichText render={text} serializeHyperlink={CustomPrismicLink} />
  </>
);
